/* istanbul ignore file */

export enum Blue {
  V10 = '#BCE8FF',
  V30 = '#98DCFF',
  V50 = '#61C9FF',
  V100 = '#0EADFF',
  V150 = '#049EEE',
  V200 = '#0096E5',
}

export enum Purple {
  V10 = '#E5D2F1',
  V30 = '#D7BAE9',
  V50 = '#C195DE',
  V100 = '#A05DCD',
  V150 = '#9043BE',
  V200 = '#8936B6',
}

export enum Green {
  V10 = '#B9EBE0',
  V30 = '#93E0D0',
  V50 = '#59D0B6',
  V100 = '#02B790',
  V150 = '#00A881',
  V200 = '#00A179',
}

export enum Red {
  V10 = '#FCC9D0',
  V30 = '#FAACB7',
  V50 = '#F77F91',
  V100 = '#F23C57',
  V150 = '#E1143D',
  V200 = '#C50A33',
}

export enum Orange {
  V10 = '#FFDFB8',
  V30 = '#FFCD92',
  V50 = '#FFB257',
  V100 = '#FF8A00',
  V150 = '#EE7A00',
  V200 = '#E57200',
}

export enum Yellow {
  V50 = '#FEFF85',
  V100 = '#FFFC00',
  V150 = '#FCF000',
  V200 = '#FFD301',
}

export enum Gray {
  V50 = '#F7F8F9',
  V100 = '#F0F1F2',
  V150 = '#E9EAEB',
  V200 = '#D4D5D6',
  V250 = '#C7C7CC',
  V300 = '#858D94',
}

export enum Black {
  V50 = '#53575B',
  V100 = '#3A3E41',
  V150 = '#121314',
  V200 = '#000000',
}

export const WHITE = '#FFFFFF';

export type ColorPalette =
  | typeof Black[keyof typeof Black]
  | typeof Blue[keyof typeof Blue]
  | typeof Green[keyof typeof Green]
  | typeof Gray[keyof typeof Gray]
  | typeof Orange[keyof typeof Orange]
  | typeof Purple[keyof typeof Purple]
  | typeof Red[keyof typeof Red]
  | typeof Yellow[keyof typeof Yellow]
  | typeof WHITE;
